module.exports = __webpack_public_path__ + "img/data_center_05.d947ea24.png";